import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

/**
 * Wrapper for every Auth-M route. The single `.auth-m` element scopes the
 * package's design tokens + utility classes (see styles/auth-m.scss) to the
 * auth flows, so they never leak into (or collide with) the rest of HubWare
 * (Bootstrap / Angular Material). All auth-m pages render in this outlet.
 */
@Component({
  selector: 'app-auth-m-shell',
  standalone: true,
  imports: [RouterOutlet],
  template: `<div class="auth-m"><router-outlet></router-outlet></div>`,
})
export class AuthMShellComponent {}
